import { createFileRoute } from '@tanstack/react-router';
import { parseTemplatesSearch } from '@/admin/copy/templates/search';
import { TemplatesScreen } from '@/admin/copy/templates/TemplatesScreen';

export const Route = createFileRoute('/admin/templates')({
  component: TemplatesScreen,
  staticData: { minTier: 'ADMIN' },
  validateSearch: parseTemplatesSearch,
});
